import brand from "../../assets/brand.png";
import { useSelector } from "react-redux";
import "./Styles/sidebar.css";
import { MdOutlineCategory } from "react-icons/md";
import { MdOutlineCollectionsBookmark } from "react-icons/md";
import order from "../../assets/order.png";

const StatCard = ({ label, icon, value }) => (
  <div className="admin-stat-card">
    <span className="admin-stat-label">{label}</span>
    <div className="admin-stat-card-inner">
      <div className="admin-stat-icon">{icon}</div>
      <p className="admin-stat-value">{value}</p>
    </div>
  </div>
);

const CardAdmin = () => {
  const productsCount = useSelector((state) => state.product.productsCount);
  const CategoryCount = useSelector((state) => state.category.categoryCount);
  const collectionCount = useSelector(
    (state) => state.collection.collectionCount
  );
  const { AllOrdersCount } = useSelector((state) => state.order);

  return (
    <div className="d-flex gap-4 flex-wrap">
      <StatCard
        label="Products"
        value={productsCount}
        icon={<img alt="products" src={brand} />}
      />
      <StatCard
        label="Categories"
        value={CategoryCount}
        icon={<MdOutlineCategory className="text-white" />}
      />
      <StatCard
        label="Collections"
        value={collectionCount}
        icon={<MdOutlineCollectionsBookmark className="text-white" />}
      />
      <StatCard
        label="Orders"
        value={AllOrdersCount}
        icon={<img alt="orders" src={order} />}
      />
    </div>
  );
};

export default CardAdmin;
